module.exports = __webpack_public_path__ + "media/images/emblems/Thalheim-blazon-72893c0c6fba460750629a9530d94b62.svg";